<app-loading *ngIf="contentReady"></app-loading>

<div
  class="bbm-page daily-expenses-mobile"
  [class.rtl]="isAr"
  [dir]="isAr ? 'rtl' : 'ltr'"
>
  <div class="bbm-shell">

    <!-- HERO -->
    <section class="bbm-hero">

      <div class="bbm-hero-top">

        <div class="bbm-main-info">

          <div class="bbm-avatar bbm-avatar-contain">
            <img
              src="/assets/income.png"
              [alt]="'income' | transloco"
            >
          </div>

          <div class="bbm-hero-copy">
            <span class="bbm-eyebrow">
              {{ 'expenses & revenue' | transloco }}
            </span>

            <h2>
              {{ 'expenses & revenue' | transloco }}
            </h2>

            <p>
              {{ selectedYear }} / {{ selectedMonth }}

              <span *ngIf="day">
                • {{ day }}
              </span>
            </p>
          </div>

        </div>

        <button
          type="button"
          class="bbm-hero-icon noPrint"
          aria-label="Print"
          onclick="window.print()"
        >
          <i class="fa-solid fa-print"></i>
        </button>

      </div>

      <!-- QUICK ACTIONS -->
      <div class="bbm-actions-grid bbm-hero-actions noPrint">

        <button
          type="button"
          class="bbm-action-btn bbm-action-success"
          (click)="addRevenues()"
        >
          <i class="fa-solid fa-plus"></i>

          <span>
            {{ 'Add Revenue' | transloco }}
          </span>
        </button>

        <button
          type="button"
          class="bbm-action-btn bbm-action-danger"
          (click)="addExpenses()"
        >
          <i class="fa-solid fa-minus"></i>

          <span>
            {{ 'Add expenses' | transloco }}
          </span>
        </button>

      </div>

    </section>

    <!-- ADMIN ACTIONS -->
    <section
      *ngIf="isAdmin"
      class="bbm-form-ticket noPrint"
    >
      <button
        type="button"
        class="bbm-collapse-toggle"
        (click)="showAdminActions = !showAdminActions"
      >
        <span>
          <i class="fa-solid fa-user-shield"></i>
          {{ 'Admin actions' | transloco }}
        </span>

        <i
          class="fa-solid"
          [class.fa-chevron-down]="!showAdminActions"
          [class.fa-chevron-up]="showAdminActions"
        ></i>
      </button>

      <div
        *ngIf="showAdminActions"
        class="bbm-collapse-panel"
      >
        <div class="bbm-form-grid">

          <!-- WAREHOUSE -->
          <div class="bbm-field">
            <label for="finance-warehouse">
              {{ 'Pospage' | transloco }}
            </label>

            <select
              id="finance-warehouse"
              class="bbm-control mobile-input"
              [(ngModel)]="warehouseId"
              (change)="applyWareHouse(warehouseId)"
            >
              <option
                *ngFor="let el of allWareHouses"
                [value]="el.id"
              >
                {{ el.name }}
              </option>
            </select>
          </div>

          <!-- USER -->
          <div class="bbm-field">
            <label for="finance-user">
              {{ 'Users' | transloco }}
            </label>

            <select
              id="finance-user"
              class="bbm-control mobile-input"
              (change)="userFilter($any($event.target).value || null)"
            >
              <option value="">
                {{ 'All Users' | transloco }}
              </option>

              <option
                *ngFor="let el of allUsers"
                [value]="el.id"
              >
                {{ el.username }}
              </option>
            </select>
          </div>

        </div>

        <div class="bbm-actions-grid bbm-actions-three">

          <button
            type="button"
            class="bbm-action-btn bbm-action-primary"
            routerLink="/employeescollecting.mobile"
          >
            <i class="fa-solid fa-users"></i>

            <span>
              {{ 'employeescollecting' | transloco }}
            </span>
          </button>

          <button
            *ngIf="canShowDeliveryHeroCollecting"
            type="button"
            class="bbm-action-btn bbm-action-primary"
            routerLink="/deliveryherocollecting.mobile"
          >
            <i class="fa-solid fa-motorcycle"></i>

            <span>
              {{ 'delivery hero collecting' | transloco }}
            </span>
          </button>

          <button
            type="button"
            class="bbm-action-btn bbm-action-danger"
            (click)="getArchivedBalances()"
          >
            <i class="fa-solid fa-box-archive"></i>

            <span>
              {{ 'deleted archive' | transloco }}
            </span>
          </button>

          <button
            *ngIf="warehouseIsStore"
            type="button"
            class="bbm-action-btn bbm-action-success"
            routerLink="/financial-manager.mobile"
          >
            <i class="fa-solid fa-handshake"></i>

            <span>
              {{ 'affiliation revenue' | transloco }}
            </span>
          </button>

          <button
            type="button"
            class="bbm-action-btn bbm-action-warning"
            routerLink="/orderprofit.mobile"
          >
            <i class="fa-solid fa-chart-line"></i>

            <span>
              {{ 'orderprofit' | transloco }}
            </span>
          </button>

        </div>
      </div>
    </section>

    <!-- FILTERS -->
    <section class="bbm-form-ticket noPrint">

      <button
        type="button"
        class="bbm-collapse-toggle"
        (click)="showFilters = !showFilters"
      >
        <span>
          <i class="fa-solid fa-filter"></i>
          {{ 'Filters' | transloco }}
        </span>

        <i
          class="fa-solid"
          [class.fa-chevron-down]="!showFilters"
          [class.fa-chevron-up]="showFilters"
        ></i>
      </button>

      <div
        *ngIf="showFilters"
        class="bbm-collapse-panel"
      >
        <div class="bbm-form-grid">

          <!-- DAY -->
          <div class="bbm-field bbm-field-wide">
            <label for="finance-day">
              {{ 'byday' | transloco }}
            </label>

            <div class="bb-booking-calendar-field" [dir]="isAr ? 'rtl' : 'ltr'">
              <button
                type="button"
                class="bb-booking-calendar-trigger"
                id="finance-day"
                (click)="toggleDayCalendar()"
                [ngClass]="{
                  'is-valid': day
                }"
              >
                <span>{{ getDayDisplay() }}</span>
                <i class="fa-solid fa-calendar-days"></i>
              </button>

              @if(showDayCalendar) {
              <div class="bb-booking-calendar-panel">
                <div class="bb-booking-calendar-head">
                  <button type="button" (click)="previousDayCalendarMonth()">
                    <i class="fa-solid" [ngClass]="isAr ? 'fa-chevron-right' : 'fa-chevron-left'"></i>
                  </button>

                  <strong>{{ getDayCalendarTitle() }}</strong>

                  <button type="button" (click)="nextDayCalendarMonth()">
                    <i class="fa-solid" [ngClass]="isAr ? 'fa-chevron-left' : 'fa-chevron-right'"></i>
                  </button>
                </div>

                <div class="bb-booking-calendar-weekdays">
                  @for(dayName of getDayCalendarWeekDays(); track dayName) {
                  <span>{{ dayName }}</span>
                  }
                </div>

                <div class="bb-booking-calendar-grid">
                  @for(calendarDay of getDayCalendarDays(); track calendarDay.date.getTime()) {
                  <button
                    type="button"
                    class="bb-booking-calendar-day"
                    [class.other-month]="!calendarDay.isCurrentMonth"
                    [class.today]="calendarDay.isToday"
                    [class.selected]="calendarDay.isSelected"
                    [disabled]="calendarDay.isDisabled"
                    (click)="selectDayCalendarDate(calendarDay.date)"
                  >
                    {{ calendarDay.dayNumber }}
                  </button>
                  }
                </div>
              </div>
              }
            </div>
          </div>

          <!-- YEAR -->
          <div class="bbm-field">
            <label for="finance-year">
              {{ 'bymonth' | transloco }}
            </label>

            <select
              id="finance-year"
              class="bbm-control mobile-input"
              [(ngModel)]="selectedYear"
              (change)="getByMonth()"
            >
              <option
                *ngFor="let year of years"
                [value]="year"
              >
                {{ year }}
              </option>
            </select>
          </div>

          <!-- MONTH -->
          <div class="bbm-field">
            <label for="finance-month">
              {{ 'bymonth' | transloco }}
            </label>

            <select
              id="finance-month"
              class="bbm-control mobile-input"
              [(ngModel)]="selectedMonth"
              (change)="getByMonth()"
            >
              <option
                *ngFor="let month of months"
                [value]="month.value"
              >
                {{ isAr ? month.name_ar : month.name_en }}
              </option>
            </select>
          </div>

        </div>

        <div class="bbm-form-actions">
          <button
            type="button"
            class="bbm-action-btn bbm-action-warning bbm-action-wide"
            (click)="clearDayFilter()"
          >
            <i class="fa-solid fa-calendar-days"></i>

            <span>
              {{ 'bymonth' | transloco }}
            </span>
          </button>
        </div>
      </div>

    </section>

    <!-- SUMMARY -->
    <section class="bbm-details-grid bbm-summary-grid bbm-section">

      <!-- TOTAL REVENUE -->
      <div class="bbm-detail-chip bbm-detail-success">
        <i class="fa-solid fa-arrow-trend-up"></i>

        <span>
          {{ 'total' | transloco }}
          {{ 'Revenue' | transloco }}
        </span>

        <strong class="bbm-money-value">
          {{ revenueTotal | number:'1.2-2' }}
          {{ 'egp' | transloco }}
        </strong>
      </div>

      <!-- TOTAL EXPENSES -->
      <div class="bbm-detail-chip bbm-detail-danger">
        <i class="fa-solid fa-arrow-trend-down"></i>

        <span>
          {{ 'total' | transloco }}
          {{ 'expenses' | transloco }}
        </span>

        <strong class="bbm-money-value">
          {{ expenseTotal | number:'1.2-2' }}
          {{ 'egp' | transloco }}
        </strong>
      </div>

      <!-- NET -->
      <div
        class="bbm-detail-chip bbm-detail-wide"
        [class.bbm-detail-success]="netTotal > 0"
        [class.bbm-detail-danger]="netTotal < 0"
        [class.bbm-detail-primary]="netTotal === 0"
      >
        <i class="fa-solid fa-scale-balanced"></i>

        <span>
          {{ 'Revenue' | transloco }} -
          {{ 'expenses' | transloco }}
        </span>

        <strong class="bbm-money-value">
          {{ netTotal | number:'1.2-2' }}
          {{ 'egp' | transloco }}
        </strong>
      </div>

      <!-- REVENUE BREAKDOWN -->
      <div class="bbm-detail-chip">
        <i class="fa-solid fa-wallet"></i>

        <span>
          {{ 'Revenue' | transloco }}
        </span>

        <div class="bbm-split-list">

          <div class="bbm-split-row">
            <small>
              {{ 'cash' | transloco }}
            </small>

            <b>
              {{ revenueTotalCash | number:'1.2-2' }}
            </b>
          </div>

          <div class="bbm-split-row">
            <small>
              {{ 'online payment' | transloco }}
            </small>

            <b>
              {{ revenueTotalOnlinePayment | number:'1.2-2' }}
            </b>
          </div>

        </div>
      </div>

      <!-- EXPENSE BREAKDOWN -->
      <div class="bbm-detail-chip">
        <i class="fa-solid fa-receipt"></i>

        <span>
          {{ 'expenses' | transloco }}
        </span>

        <div class="bbm-split-list">

          <div class="bbm-split-row">
            <small>
              {{ 'cash' | transloco }}
            </small>

            <b>
              {{ expenseTotalCash | number:'1.2-2' }}
            </b>
          </div>

          <div class="bbm-split-row">
            <small>
              {{ 'online payment' | transloco }}
            </small>

            <b>
              {{ expenseTotalOnlinePayment | number:'1.2-2' }}
            </b>
          </div>

        </div>
      </div>

    </section>

    <!-- SHOW / HIDE CHIPS -->
    <section class="bbm-chip-row noPrint">

      <button
        type="button"
        class="bbm-filter-chip"
        [class.active]="showExpenses"
        (click)="toggleExpenses()"
      >
        <i class="fa-solid fa-receipt"></i>

        <span>
          {{
            showExpenses
              ? ('Hide Expenses' | transloco)
              : ('Show Expenses' | transloco)
          }}
        </span>
      </button>

      <button
        type="button"
        class="bbm-filter-chip"
        [class.active]="showRevenues"
        (click)="toggleRevenues()"
      >
        <i class="fa-solid fa-chart-line"></i>

        <span>
          {{
            showRevenues
              ? ('Hide Revenues' | transloco)
              : ('Show Revenues' | transloco)
          }}
        </span>
      </button>

    </section>

    <!-- TABS -->
    <section class="bbm-tabs noPrint">

      <button
        *ngIf="showExpenses"
        type="button"
        class="bbm-tab-btn bbm-tab-danger"
        [class.active]="activeTab === 'expenses'"
        (click)="activeTab = 'expenses'"
      >
        <span>
          {{ expenses.length || 0 }}
        </span>

        {{ 'expenses' | transloco }}
      </button>

      <button
        *ngIf="showRevenues"
        type="button"
        class="bbm-tab-btn bbm-tab-success"
        [class.active]="activeTab === 'revenues'"
        (click)="activeTab = 'revenues'"
      >
        <span>
          {{ Revenues.length || 0 }}
        </span>

        {{ 'Revenue' | transloco }}
      </button>

    </section>

    <!-- EXPENSE RECORDS -->
    <section
      *ngIf="showExpenses && activeTab === 'expenses'"
      class="bbm-records-section"
    >

      <div class="bbm-list-head">
        <div>
          <span>
            {{ 'expenses' | transloco }}
          </span>

          <h3>
            {{ 'expenses' | transloco }}
          </h3>
        </div>

        <span class="bbm-value-pill bbm-value-danger">
          {{ expenseTotal | number:'1.2-2' }}
          {{ 'egp' | transloco }}
        </span>
      </div>

      <!-- EMPTY EXPENSES -->
      <div
        *ngIf="!expenses.length"
        class="bbm-empty-state"
      >
        <i class="fa-solid fa-receipt"></i>

        <h4>
          {{ 'No Data' | transloco }}
        </h4>
      </div>

      <!-- EXPENSE CARDS -->
      <div class="bbm-ticket-list">

        <article
          *ngFor="let ex of expenses; trackBy: trackById"
          class="bbm-ticket bbm-ticket-danger"
          [class.bbm-ticket-deleted]="ex.deleted_by"
        >

          <div class="bbm-ticket-top">

            <div class="bbm-main-info">

              <div class="bbm-avatar">
                <i class="fa-solid fa-arrow-trend-down"></i>
              </div>

              <div class="bbm-copy">
                <span>
                  {{ 'amount' | transloco }}
                </span>

                <h3 class="bbm-money-value">
                  {{ ex.amount }}
                  {{ 'egp' | transloco }}
                </h3>
              </div>

            </div>

            <button
              *ngIf="!ex.deleted_by"
              type="button"
              class="bbm-action-btn bbm-action-danger bbm-icon-action noPrint"
              (click)="delete(0, ex.id)"
            >
              <i class="fa-solid fa-xmark"></i>
            </button>

          </div>

          <div class="bbm-details-grid">

            <div class="bbm-detail-chip">
              <i class="fa-solid fa-credit-card"></i>

              <span>
                {{ 'payment_type' | transloco }}
              </span>

              <strong>
                {{ paymentTypeLabel(ex.amount_type) }}
              </strong>
            </div>

            <div class="bbm-detail-chip bbm-detail-wide">
              <i class="fa-solid fa-file-lines"></i>

              <span>
                {{ 'reason' | transloco }}
              </span>

              <strong>
                {{ ex.note || '-' }}
              </strong>
            </div>

            <div
              class="bbm-detail-chip"
              *ngIf="translateTypeEnum(ex.type)"
            >
              <i class="fa-solid fa-tag"></i>

              <span>
                {{ 'type' | transloco }}
              </span>

              <strong>
                {{ translateTypeEnum(ex.type) }}
              </strong>
            </div>

            <div class="bbm-detail-chip">
              <i class="fa-solid fa-user-shield"></i>

              <span>
                {{ 'admin' | transloco }}
              </span>

              <strong>
                {{ ex.username || '-' }}
              </strong>
            </div>

            <div
              class="bbm-detail-chip bbm-detail-danger bbm-detail-wide"
              *ngIf="ex.deleted_by"
            >
              <i class="fa-solid fa-user-xmark"></i>

              <span>
                {{ 'deleted by' | transloco }}
              </span>

              <strong>
                {{ ex.deleted_by }}
              </strong>
            </div>

          </div>

        </article>

      </div>

    </section>

    <!-- REVENUE RECORDS -->
    <section
      *ngIf="showRevenues && activeTab === 'revenues'"
      class="bbm-records-section"
    >

      <div class="bbm-list-head">
        <div>
          <span>
            {{ 'Revenue' | transloco }}
          </span>

          <h3>
            {{ 'Revenue' | transloco }}
          </h3>
        </div>

        <span class="bbm-value-pill bbm-value-success">
          {{ revenueTotal | number:'1.2-2' }}
          {{ 'egp' | transloco }}
        </span>
      </div>

      <!-- EMPTY REVENUES -->
      <div
        *ngIf="!Revenues.length"
        class="bbm-empty-state"
      >
        <i class="fa-solid fa-chart-line"></i>

        <h4>
          {{ 'No Data' | transloco }}
        </h4>
      </div>

      <!-- REVENUE CARDS -->
      <div class="bbm-ticket-list">

        <article
          *ngFor="let revenue of Revenues; trackBy: trackById"
          class="bbm-ticket bbm-ticket-success"
          [class.bbm-ticket-deleted]="revenue.deleted_by"
        >

          <div class="bbm-ticket-top">

            <div class="bbm-main-info">

              <div class="bbm-avatar">
                <i class="fa-solid fa-arrow-trend-up"></i>
              </div>

              <div class="bbm-copy">
                <span>
                  {{ 'amount' | transloco }}
                </span>

                <h3 class="bbm-money-value">
                  {{ revenue.amount }}
                  {{ 'egp' | transloco }}
                </h3>
              </div>

            </div>

            <button
              *ngIf="!revenue.deleted_by"
              type="button"
              class="bbm-action-btn bbm-action-danger bbm-icon-action noPrint"
              (click)="delete(1, revenue.id)"
            >
              <i class="fa-solid fa-xmark"></i>
            </button>

          </div>

          <div class="bbm-details-grid">

            <div class="bbm-detail-chip">
              <i class="fa-solid fa-credit-card"></i>

              <span>
                {{ 'payment_type' | transloco }}
              </span>

              <strong>
                {{ paymentTypeLabel(revenue.amount_type) }}
              </strong>
            </div>

            <div class="bbm-detail-chip bbm-detail-wide">
              <i class="fa-solid fa-file-lines"></i>

              <span>
                {{ 'reason' | transloco }}
              </span>

              <strong>
                {{ revenue.note || '-' }}
              </strong>
            </div>

            <div
              class="bbm-detail-chip"
              *ngIf="translateTypeEnum(revenue.type)"
            >
              <i class="fa-solid fa-tag"></i>

              <span>
                {{ 'type' | transloco }}
              </span>

              <strong>
                {{ translateTypeEnum(revenue.type) }}
              </strong>
            </div>

            <div class="bbm-detail-chip">
              <i class="fa-solid fa-user-shield"></i>

              <span>
                {{ 'admin' | transloco }}
              </span>

              <strong>
                {{ revenue.username || '-' }}
              </strong>
            </div>

            <div
              class="bbm-detail-chip bbm-detail-danger bbm-detail-wide"
              *ngIf="revenue.deleted_by"
            >
              <i class="fa-solid fa-user-xmark"></i>

              <span>
                {{ 'deleted by' | transloco }}
              </span>

              <strong>
                {{ revenue.deleted_by }}
              </strong>
            </div>

          </div>

        </article>

      </div>

    </section>

  </div>
</div>

<!-- ADD REVENUE / EXPENSE MODAL -->
<div
  *ngIf="showFinPopUp"
  class="bbm-modal-backdrop noPrint"
  [dir]="isAr ? 'rtl' : 'ltr'"
>
  <section
    class="bbm-modal-card"
    role="dialog"
    aria-modal="true"
  >

    <div class="bbm-modal-handle"></div>

    <div class="bbm-form-head">

      <div class="bbm-main-info">

        <div class="bbm-avatar bbm-avatar-contain">
          <img
            src="/assets/income.png"
            [alt]="'income' | transloco"
          >
        </div>

        <div>
          <span class="bbm-eyebrow">
            {{ 'expenses & revenue' | transloco }}
          </span>

          <h4>
            {{
              finId == 1
                ? ('Add expenses' | transloco)
                : ('Add Revenue' | transloco)
            }}
          </h4>
        </div>

      </div>

      <button
        type="button"
        class="bbm-action-btn bbm-action-danger bbm-icon-action"
        (click)="close()"
      >
        <i class="fa-solid fa-xmark"></i>
      </button>

    </div>

    <div class="bbm-modal-list">

      <!-- AMOUNT -->
      <div class="bbm-modal-row">
        <label for="financial-amount">
          {{ 'amount' | transloco }}
        </label>

        <input
          id="financial-amount"
          class="bbm-control mobile-input"
          type="number"
          inputmode="decimal"
          [(ngModel)]="amount"
          placeholder="{{ 'amount' | transloco }}"
        >
      </div>

      <!-- NOTE -->
      <div class="bbm-modal-row">
        <label for="financial-note">
          {{ 'note' | transloco }}
        </label>

        <input
          id="financial-note"
          class="bbm-control mobile-input"
          type="text"
          [(ngModel)]="note"
          placeholder="{{ 'note' | transloco }}"
        >
      </div>

      <!-- PAYMENT TYPE -->
      <div class="bbm-modal-row">
        <label for="financial-payment-type">
          {{ 'payment_type' | transloco }}
        </label>

        <select
          id="financial-payment-type"
          class="bbm-control mobile-input"
          [(ngModel)]="amount_type"
        >
          <option value="0">
            {{ 'cash' | transloco }}
          </option>

          <option value="1">
            {{ 'vodafone cash' | transloco }}
          </option>

          <option value="2">
            {{ 'instapay' | transloco }}
          </option>

          <option value="3">
            {{ 'online payment' | transloco }}
          </option>

          <option value="4">
            {{ 'bank transfer' | transloco }}
          </option>

          <option value="5">
            {{ 'credit' | transloco }}
          </option>
        </select>
      </div>

    </div>

    <div class="bbm-form-actions">

      <button
        type="button"
        class="bbm-action-btn bbm-action-primary"
        (click)="onSubmit()"
      >
        <i class="fa-solid fa-check"></i>

        <span>
          {{ 'Submit' | transloco }}
        </span>
      </button>

      <button
        type="button"
        class="bbm-action-btn bbm-action-danger"
        (click)="close()"
      >
        <i class="fa-solid fa-xmark"></i>

        <span>
          {{ 'close' | transloco }}
        </span>
      </button>

    </div>

  </section>
</div>